module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "page-header"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "",
      "type": "inverse fixed-top"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand"
  }, [_c('h1', {
    staticClass: "navbar-brand"
  }, [_c('span', {
    staticClass: "oldtimers-logo"
  }, [_vm._v("Oldtimers")]), _vm._v(" Garage")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-navbar-nav', [_c('b-nav-item', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.title.main.home')))])], 1)], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-item', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateLang('cs')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/flag/flag-cs.png"),
      "alt": "cs",
      "title": "Czech"
    }
  })])]), _vm._v(" "), _c('b-nav-item', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateLang('en')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/flag/flag-en.png"),
      "alt": "en",
      "title": "English"
    }
  })])])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto navbar-right",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/cars"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.title.site.our_cars')))])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-259d46fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = 1201
// module chunks = 1